// タイトルハッシュ
export const HEADER_TITLES = {
  HEADER_LOGIN: 'ログイン',
  HEADER_REPORT: 'レポート',
  HEADER_REPORT_DETAIL: 'レポート詳細画面',
  HEADER_INQUIRY: '問い合わせ',
}
export const HEADER_LOGIN: string = 'HEADER_LOGIN'
export const HEADER_LOGIN_SUCCESS: string = 'HEADER_LOGIN_SUCCESS'
export const HEADER_REPORT: string = 'HEADER_REPORT'
export const HEADER_REPORT_SUCCESS: string = 'HEADER_REPORT_SUCCESS'
export const HEADER_REPORT_DETAIL: string = 'HEADER_REPORT_DETAIL'
export const HEADER_REPORT_DETAIL_SUCCESS: string =
  'HEADER_REPORT_DETAIL_SUCCESS'
export const HEADER_INQUIRY: string = 'HEADER_INQUIRY'
export const HEADER_INQUIRY_SUCCESS: string = 'HEADER_INQUIRY_SUCESS'



// WEBPACK FOOTER //
// ./src/constants/header.constant.ts